<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import config from '@/config'
import type { MenuConfig } from '@/model/config'

const route = useRoute()

const props = defineProps({
  onClick: {
    type: Function as PropType<(id: string) => void>,
    default: () => {}
  }
})

const isActive = (link: string) => {
  // highlight the parent section nav item for routes that share a pageKey but live outside /:pageKey (e.g. /admin/:pageKey/drafts)
  if (route.meta.pageKey && link === `/${route.meta.pageKey}`) return true
  return route.matched.some(({ path }) => {
    if (path === '/') return link === path
    return link.indexOf(path) === 0
  })
}

const navItems = computed(() => {
  const menuConfig: MenuConfig[] = config.website.menu ?? []
  return menuConfig.map((item) => {
    return {
      ...item,
      'aria-current': isActive(item.to) ? 'page' : undefined
    }
  })
})
</script>

<template>
  <!-- pass a dummy nav-items to satisfy props check, we're overriding the slot anyway -->
  <DsfrNavigation id="main-nav" tabindex="-1" :nav-items="[]">
    <DsfrNavigationItem v-for="(navItem, idx) of navItems" :key="idx">
      <a
        v-if="navItem.to && navItem.text && navItem.external"
        class="fr-nav__link"
        :href="navItem.to"
        target="_blank"
        rel="noopener noreferrer"
        >{{ navItem.text }}</a
      >
      <DsfrNavigationMenuLink
        v-else-if="navItem.to && navItem.text"
        v-bind="navItem"
        @toggle-id="props.onClick"
      />
    </DsfrNavigationItem>
  </DsfrNavigation>
</template>
